import { Breadcrumb } from "antd";
import React, { memo } from "react";
import { Link } from "react-router-dom";

import "./Breadcrumbs.scss";

const Breadcrumbs = ({
  breadcrumbsList,
  className = "",
  separator = "/",
  rightComponent = <></>,
}) => {
  const items = breadcrumbsList
    ? [
        {
          title: (
            <Link to="/dashboard" className="fs22">
              Dashboard
            </Link>
          ),
        },
        ...breadcrumbsList?.map(({ text, link }) => ({
          title: link ? (
            <Link to={link} className="fs22">
              {text}
            </Link>
          ) : (
            text
          ),
        })),
      ]
    : "";

  return (
    <div className={`antdBreadcrumbSection fw-bold bg-white ${className}`}>
      <Breadcrumb separator={separator} className="fs22" items={items} />
    </div>
  );
};

export default memo(Breadcrumbs);
